import { Pipe, PipeTransform } from '@angular/core';
import { ARBleParcel, ARBleOrderItem } from '../models/agrorendement-ble.model';

// FIXME mettre en commun avec Colza

@Pipe({
  name: 'extractParcelNameFromOrderItems',
  standalone: true,
})
export class ExtractParcelNameFromOrderItemsPipe implements PipeTransform {
  transform(orderItems: ARBleOrderItem[], attr: any): any {
    if (orderItems.length > 1) {
      return orderItems.length + ' parcelles';
    } else {
      return orderItems[0].parcel.name;
    }
  }
}

@Pipe({
  name: 'extractFarmNameFromOrderItems',
  standalone: true,
})
export class ExtractFarmNameFromOrderItemsPipe implements PipeTransform {
  transform(orderItems: ARBleOrderItem[], attr: any): any {
    return orderItems[0].parcel.farm.name;
  }
}
